module.exports = __webpack_public_path__ + "svg/icon-carret-down-thin.svg";